import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import map from 'lodash/map';
import round from 'lodash/round';
import cloneDeep from 'lodash/cloneDeep';
import size from 'lodash/size';
import remove from 'lodash/remove';

import Button from '../common/Button';
import QuotesCard from './QuotesCard';
import Gmaps from '../MyRequest/Gmaps';
import CustomScroll from 'react-custom-scroll';
import InputRange from 'react-input-range';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import { DropdownButton } from 'react-bootstrap';
import Rating from 'react-rating';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import CreateRequestPopup from '../common/CreateRequestPopup';
import SearchEmptyState from '../EmptyState/SearchEmptyState';
import RequestMobileSort from '../common/RequestMobileSort';
import RequestFilter from './RequestFilter';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import imageExists from  'image-exists';

export default class RequestCard extends Component {
  constructor(props) {
    super(props);
    this.toggleSwitchVal = { Open24_7: false, PickupDrop: false, showFavourites: false, byCash: false, byCreditcard: false }
    this.checkBox = { all: false, carService: false, carWash: false, carRepair: false };
    this.serviceTypes = [];
    let vendorList = cloneDeep(props.commonReducer.vendorsListFromSearch);
    map(vendorList, (val, key) => {
      if (key == 0) {
        vendorList[key].isActive = true;
      } else {
        vendorList[key].isActive = false;
      }
    });
    this.state = {
      mobileSortItem: false,
      mobileFilterItem: false,
      bookServiceModalVisible: false,
      locationSearch: {
        lat: undefined,
        lng: undefined,
        pinImage: ""
      },
      selectedDate: moment(),
      filterdropdownVisible: false,
      setCenter: false,
      mapsCenter: { lat: 12.9952672, lng: 77.5905857 },
      switched: false,
      filterSort: "DistNF",
      filterdropdown: false,
      sortBydropdown: false,
      daySelected: {
        "sunday": false, "monday": false, "tuesday": false, "wednesday": false, "thrusday": false, "friday": false, "saturday": false
      },
      rangefrom: undefined,
      rangeto: undefined,
      daySelectedKey: [false, false, false, false, false, false, false],
      daySelectedValue: [],
      open: false,
      jobUpdates: "quotes",
      currentWidth: '',
      activelatitude: '',
      activelongitue: '',
      selectedVendorProfile: '',
      jobCardDetails: vendorList.length ? vendorList : [],
      quotation: true,
      messages: false,
      rangeFromDefault: moment('2016-12-19T00:00:00+05:30'),
      rangeToDefault: moment('2016-12-19T23:59:00+05:30'),
      mapView: true,
      quotationView: false,
      activeSvg: 'data:image/svg+xml,%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2042%20%2836781%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3Elocation-pin%20copy%209%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/mask%3E%0A%20%20%20%20%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin-copy-9%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%2323AE49%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url%28%23mask-2%29%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3Ctext%20transform%3D%22translate%2818.5%2021%29%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E',
      svg: 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2042%20(36781)%20-%20http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%20--%3E%0A%20%20%20%20%3Ctitle%3ERectangle%2010%20Copy%203%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%23EE3124%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url(%23mask-2)%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Ctext%20transform%3D%22translate(18.5%2021)%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E',
      svgEnd: '</text>%0A</svg>',
      distValue: { min: 0, max: 20 },
      priceValue: { min: 10, max: 70 },
      ratingValue: 0,
      inValidTime: false,
      sortValue: undefined,
      filterActivated: undefined,
    };
    this.removeFav = this.removeFav.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.windowWidth = this.windowWidth.bind(this);
  }

  componentWillMount() {
    this.updateDimensions();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition.bind(this));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
    document.body.addEventListener('mousedown', this.bodyClick.bind(this));
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer.vendorsListFromSearch) {
      let vendorList = cloneDeep(nextProps.commonReducer.vendorsListFromSearch);
      map(vendorList, (val, key) => {
        if (key == 0) {
          vendorList[key].isActive = true;
        } else {
          vendorList[key].isActive = false;
        }
      });
      this.setState({ jobCardDetails: vendorList, mapsCenter: vendorList.length ? { lat: Number(vendorList[0].latitude), lng: Number(vendorList[0].longitude) } : { lat: 0, lng: 0 } });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.bodyClick.bind(this));
  }

  showPosition(position) {
    let positionVal = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      pinImage: `${imageBasePath}/images/map_blue_pointer.png`
    };
    this.setState({ locationSearch: positionVal });
  }


  jobDetail(val) {
    this.setState({ jobUpdates: val });
  }

  TimePickerChange(type, value) {
    // if (type == "timeFrom") {
    //   this.setState({ TimePickerFrom: value });
    // } else {
    //   this.setState({ TimePickerTo: value });
    // }
  }

  bodyClick(e) {
    if ((e.target.closest('.filter-dropdown') || e.target.closest('.showFilters')) && (!this.state.filterdropdown)) {
      this.setState({ filterdropdown: true, sortBydropdown: false })
    } else if ((e.target.closest('.showSortBy') || e.target.closest('.sortFilter')) && (!this.state.sortBydropdown)) {
      this.setState({ sortBydropdown: true, filterdropdown: false })
    } else if (e.target.closest('.rc-time-picker-panel')) {
      this.setState({ filterdropdown: true, sortBydropdown: false })
    }
    else if (e.target.closest('.Filterby') == null && e.target.closest('.sortFilter') == null) {
      this.setState({ filterdropdown: false, sortBydropdown: false })
    }
  }

  filterDropDownFunc(e) {
    if (!this.state.filterdropdownVisible) {
      this.setState({ filterdropdown: e })
    }
  }

  changeCheckbox(val) {
    if (val == "all") {
      if (this.checkBox.all == false) {
        this.serviceTypes = [1, 2, 3];
        this.checkBox = { all: true, carService: true, carWash: true, carRepair: true };
      } else {
        this.serviceTypes = [];
        this.checkBox = { all: false, carService: false, carWash: false, carRepair: false };
      }
    } else {
      this.checkBox["all"] = false;
      this.checkBox[val] = !this.checkBox[val];
      if (val == "carWash") {
        if (this.checkBox[val]) {
          this.serviceTypes.push(1);
        } else {
          remove(this.serviceTypes, (n) => {
            return n == 1;
          });
        }
      }
      if (val == "carService") {
        if (this.checkBox[val]) {
          this.serviceTypes.push(2);
        } else {
          remove(this.serviceTypes, (n) => {
            return n == 2;
          });
        }
      }
      if (val == "carRepair") {
        if (this.checkBox[val]) {
          this.serviceTypes.push(3);
        } else {
          remove(this.serviceTypes, (n) => {
            return n == 3;
          });
        }
      }
    }
    this.setState({
      checkBoxVal: !this.state.checkBoxVal,
    });
  }

  updateDimensions() {
    const windowWidth = this.windowWidth();
    this.setState({ 'currentWidth': windowWidth });
  }

  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
      body = window.document.body;
    return window.document.compatMode === "CSS1Compat" && docElemProp || body && body.clientWidth || docElemProp;
  }

  btnClickFunc(garage) {
    this.setState({
      mapView: false,
      quotationView: true,
      quotation: true,
      messages: false,
      bookServiceModalVisible: true,
      selectedVendorProfile: garage
    });
  }

  viewMessaging() {
    this.setState({ mapView: false, quotationView: true, quotation: false, messages: true })
  }

  mapClick(map) {
    let update, newDetails = [];
    this.state.jobCardDetails.map((value, key) => {
      if (round(Number(value.latitude), 6) == round(map.latLng.lat(), 6) && round(Number(value.longitude), 6) == round(map.latLng.lng(), 6)) {
        update = { ...value, pinImage: this.state.activeSvg + key + this.state.svgEnd, isActive: true, zIndex: 999 };
      } else {
        update = { ...value, pinImage: this.state.svg + key + this.state.svgEnd, isActive: false, zIndex: 9 };
      }
      newDetails.push(update);
    });
    this.setState({
      jobCardDetails: newDetails,
    });

    console.log(window.lastActive)

    if (window.lastActive != map.latLng.lat()) {
      this.setState({ scrollTo: Object.keys(this.currentTopEle).length > 0 ? ReactDOM.findDOMNode(this.currentTopEle).getBoundingClientRect().top : 0 });
    }

    window.lastActive = map.latLng.lat()
  }

  ClickedQuoteCard(key) {
    let update, newArray = [], centerLat = undefined, centerLng = undefined;
    this.state.jobCardDetails.map((val, index) => {
      if (index == key.key) {
        update = { ...val, isActive: true, pinImage: this.state.activeSvg + index + this.state.svgEnd, zIndex: 999 }
        centerLat = Number(val.latitude), centerLng = Number(val.longitude);
      } else {
        update = { ...val, isActive: false, pinImage: this.state.svg + index + this.state.svgEnd, zIndex: 9 }
      }
      newArray.push(update);
    });
    this.setState({
      jobCardDetails: newArray,
      mapsCenter: { lat: centerLat, lng: centerLng },
      setCenter: true
    });
  }

  closeChat() {
    this.setState({ mapView: true, quotationView: false })
  }

  viewQuotation() {
    this.setState({ quotation: !this.state.quotation, messages: !this.state.messages })
  }

  viewMessages() {
    this.setState({ quotation: !this.state.quotation, messages: !this.state.messages })
  }

  day(selDay, day) {
    let days = { ...this.state.daySelected };
    let daysValue = [...this.state.daySelectedKey];
    days[selDay] = !this.state.daySelected[selDay];
    daysValue[day] = !this.state.daySelectedKey[day];
    this.setState({
      daySelected: days,
      daySelectedKey: daysValue,
    });
  }

  filterOption(val, sortValue) {
    this.setState({
      filterSort: val,
      sortBydropdown: false,
      sortValue: sortValue,
      mobileSortItem: false
    });
  }

  switch(val) {
    this.toggleSwitchVal[val] = !this.toggleSwitchVal[val];
    if (val == 'byCash') {
      this.toggleSwitchVal.byCreditcard = false;
    } else if (val == 'byCreditcard') {
      this.toggleSwitchVal.byCash = false;
    }
    this.setState({
      switched: !this.state.switched,
    });
  }

  headingClickCallback(garageUrl) {
    this.props.router.push(appBasePath + '/vendor-profile/' + garageUrl);
  }

  clearFilter(e) {
    this.serviceTypes = [];
    this.checkBox = { all: false, carService: false, carWash: false, carRepair: false };
    this.toggleSwitchVal = { Open24_7: false,  PickupDrop: false, showFavourites: false, authorizedBusinesses: false, dealsOffers: false, byCash: false, byCreditcard: false }
    this.setState({
      ratingValue: 0,
      inValidTime: false,
      distValue: { min: 0, max: 20 },
      priceValue: { min: 10, max: 70 },
      daySelected: {
        "sunday": false, "monday": false, "tuesday": false, "wednesday": false, "thrusday": false, "friday": false, "saturday": false
      },
      daySelectedValue: [],
      daySelectedKey: [false, false, false, false, false, false, false],
      rangefrom: undefined,
      rangeto: undefined,
      rangeFromDefault: moment('2016-12-19T00:00:00+05:30'),
      rangeToDefault: moment('2016-12-19T23:59:00+05:30'),
      filterActivated: false,
    });
    this.props.filterActivated(false);
    this.props.actions.searchVendors(this.props.commonReducer.searchType, this.props.commonReducer.searchData, this.props.commonReducer.userLocation, this.state.sortValue);
  }

  ratingOnChange(rating) {
    this.setState({
      ratingValue: rating,
    });
  }

  filterSelect() {
    let filterActivated = false;
    let daysSelected = [];
    map(this.state.daySelectedKey, (value, key) => {
      if (value) {
        daysSelected.push(key + 1);
      }
    });
    if (this.toggleSwitchVal && this.toggleSwitchVal['byCash'] || this.toggleSwitchVal['byCreditcard'] || this.toggleSwitchVal['showFavourites'] || this.toggleSwitchVal['Open24_7'] || this.toggleSwitchVal['PickupDrop'] || this.state.ratingValue || this.serviceTypes && this.serviceTypes.length || this.state.distValue && this.state.distValue.min && this.state.distValue.max || daysSelected.length || this.state.rangefrom || this.state.rangeTo) {
      filterActivated = true;
    }
    this.setState({
      mobileFilterItem: false,
      filterdropdown: false,
      daySelectedValue: daysSelected,
      filterActivated: filterActivated
    });
    this.props.filterActivated(filterActivated);
    this.props.actions.searchVendors(this.props.commonReducer.searchType, this.props.commonReducer.searchData, this.props.commonReducer.userLocation, this.state.sortValue, this.serviceTypes, this.state.distValue, this.toggleSwitchVal, this.state.ratingValue, daysSelected, this.state.rangefrom, this.state.rangeto);
  }

  setCenter() {
    this.setState({ setCenter: true });
  }

  hideModalCallback() {
    this.setState({ bookServiceModalVisible: false });
  }

  rangefrom(value) {
    this.setState({
      rangefrom: value.format("hh:mm A"),
      rangeFromDefault: value
    });
  }

  rangeTo(value) {
    this.setState({
      rangeto: value.format("hh:mm A"),
      rangeToDefault: value,
    });
  }

  removeFav(event, status, vendorId) {
    event.stopPropagation();
    event.preventDefault();
    this.props.actions.changeFavouriteSelection(vendorId, status, 'searchResult');
  }
  bckButton() {
    this.setState({ mobileSortItem: false, mobileFilterItem: false });
  }
  distanceRange(distValue) {
    this.setState({ distValue });
  }

  render() {
    const { commonReducer, router, actions } = this.props;
    let jobLeftGridValue = "";
    let jobRightGridValue = "";
    let infoClass = 'jobInfo ';
    let userSelectedLocation = localStorage.getItem('userSelectedLocation');
    if (this.state.currentWidth <= 1155 && this.state.currentWidth >= 992) {
      jobLeftGridValue = "col-md-7";
      jobRightGridValue = "col-md-5";
    } else if (this.state.currentWidth <= 1345 && this.state.currentWidth >= 1155) {
      jobLeftGridValue = "col-md-6";
      jobRightGridValue = "col-md-6";
    } else {
      jobLeftGridValue = "col-md-5";
      jobRightGridValue = "col-md-7";
    }

    const jobCardLocation = map(this.state.jobCardDetails, (val, key) => {
      let coverImg = '';
      if (val && val.images && val.images.length) {
        coverImg = val.images[0] && val.images[0];
      }
      return {
        lat: Number(val.latitude),
        lng: Number(val.longitude),
        pinImage: val.isActive ? this.state.activeSvg + (key + 1) + this.state.svgEnd : this.state.svg + (key + 1) + this.state.svgEnd,
        name: val.companyprofilename,
        rating: val.rating,
        distance: val.distance,
        review: val.reviews,
        image: coverImg && coverImg.medium,
        zIndex: val.zIndex ? val.zIndex : 9
      };
    });

    return (
      <div>
        <div className={localStorage.getItem('authData') ? "requestSection vendor-list-view" : "requestSection vendor-list-view search-result-noAuth"}>
          <div className="row">
            <div className="request-summary">
              <div className="row request-summary-body">
                {this.state.jobUpdates == "quotes" ? <div className="tab-quotes ">
                  <div className={localStorage.getItem('authData') ? "col-md-6 clearfix left pad0" : "col-md-7 clearfix left pad0"}>
                    <div className="quotes-view">
                      <div className="title">
                        <span className="qv-title">{commonReducer.vendorsListFromSearch && commonReducer.vendorsListFromSearch.length ? commonReducer.vendorsListFromSearch.length : 'No'} Results Found</span>
                        {/* <span className="qv-title">{this.state.jobCardDetails && this.state.jobCardDetails.length ? this.state.jobCardDetails.length + ' Results found' : 'No results found'}</span> */}
                        <span className="mob-sort-filter">
                          <i className="mdi mdi-filter-variant" onClick={() => this.setState({ mobileFilterItem: true })}></i>
                          <i className="mdi mdi-swap-vertical" onClick={() => this.setState({ mobileSortItem: true })}></i>
                        </span>
                        {
                          <div className="filterSection active">
                            <DropdownButton bsSize="small" id="dropdown-size-small" pullRight open={this.state.sortBydropdown} onToggle={() => { }} noCaret title={
                              <div className="filterLabel showSortBy">
                                <i className="mdi mdi-swap-vertical" />
                                <label>Sort by</label>
                                <i className={this.state.sortBydropdown ? "mdi mdi-chevron-up downIcon downAlign pull-right" : "mdi mdi-chevron-down downIcon downAlign pull-right"} />
                              </div>
                            }>
                              <div className="sortFilter filterCard">
                                <ul className="list-unstyled">
                                  <li onClick={() => (this.filterOption("DistNF", "distance"), size(userSelectedLocation) && this.props.actions.searchVendors(commonReducer.searchType, commonReducer.searchData, commonReducer.userLocation, "distance", this.serviceTypes, this.state.distValue, this.toggleSwitchVal, this.state.ratingValue, this.state.daySelectedValue, this.state.rangefrom, this.state.rangeto))} className={this.state.filterSort == "DistNF" ? "active" : ""}>
                                    <label>
                                      Distance - Near to Far
                                    </label>
                                    <span>
                                      <i className={this.state.filterSort == "DistNF" ? "mdi mdi-check active" : "hide"} />
                                    </span>
                                  </li>
                                  <li onClick={() => (this.filterOption("DistFN", "-distance"), size(userSelectedLocation) && this.props.actions.searchVendors(commonReducer.searchType, commonReducer.searchData, commonReducer.userLocation, "-distance", this.serviceTypes, this.state.distValue, this.toggleSwitchVal, this.state.ratingValue, this.state.daySelectedValue, this.state.rangefrom, this.state.rangeto))} className={this.state.filterSort == "DistFN" ? "active" : ""}>
                                    <label>
                                      Distance - Far to Near
                                      </label>
                                    <span>
                                      <i className={this.state.filterSort == "DistFN" ? "mdi mdi-check active" : "hide"} />
                                    </span>
                                  </li>
                                  <li onClick={() => (this.filterOption("ratingHL", "-rating"), this.props.actions.searchVendors(commonReducer.searchType, commonReducer.searchData, commonReducer.userLocation, "-rating", this.serviceTypes, this.state.distValue, this.toggleSwitchVal, this.state.ratingValue, this.state.daySelectedValue, this.state.rangefrom, this.state.rangeto))} className={this.state.filterSort == "ratingHL" ? "active" : ""}>
                                    <label>
                                      Rating - Highest to Lowest
                                    </label>
                                    <span>
                                      <i className={this.state.filterSort == "ratingHL" ? "mdi mdi-check active" : "hide"} />
                                    </span>
                                  </li>
                                  <li onClick={() => (this.filterOption("ratingLH", "rating"), this.props.actions.searchVendors(commonReducer.searchType, commonReducer.searchData, commonReducer.userLocation, "rating", this.serviceTypes, this.state.distValue, this.toggleSwitchVal, this.state.ratingValue, this.state.daySelectedValue, this.state.rangefrom, this.state.rangeto))} className={this.state.filterSort == "ratingLH" ? "active" : ""}>
                                    <label>
                                      Rating - Lowest to Highest
                                    </label>
                                    <span>
                                      <i className={this.state.filterSort == "ratingLH" ? "mdi mdi-check active" : "hide"} />
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </DropdownButton>
                          </div>}
                        {
                          <div className={this.state.filterActivated ? "filterSection active" : "filterSection"}>
                            <DropdownButton bsSize="large" onToggle={() => { }} open={this.state.filterdropdown} noCaret id="dropdown-size-large" title={
                              <div className="filterLabel showFilters ">
                                <i className="mdi mdi-filter-variant" />
                                <label>Filter</label>
                                <i className={this.state.filterdropdown ? "mdi mdi-chevron-up downIcon pull-right" : "mdi mdi-chevron-down downIcon pull-right"} />
                              </div>
                            }>
                              <li className="Filterby filterCard filter-dropdown">
                                <div className="row">
                                  <div className="filter-left">
                                    <div className="filterby-wrapper">
                                      <div className="f-card">
                                        <h5>Service Type</h5>
                                        <div className="row">
                                          <div className="col-md-6 pad0">
                                            <div className="checkbox-style checkbox-wrapper">
                                              <input type="checkbox" id="all" value="" checked={this.checkBox.all} onChange={this.changeCheckbox.bind(this, 'all')} />
                                              <label htmlFor="all" className="custom-checkbox"></label>
                                              <label htmlFor="all">
                                                All
                                              </label>
                                            </div>
                                            <div className="checkbox-style checkbox-wrapper">
                                              <input type="checkbox" id="car-wash" value="" checked={this.checkBox.carWash} onChange={this.changeCheckbox.bind(this, 'carWash')} />
                                              <label htmlFor="car-wash" className="custom-checkbox"></label>
                                              <label htmlFor="car-wash">
                                                Car Wash
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-md-6">
                                            <div className="checkbox-style checkbox-wrapper">
                                              <input type="checkbox" id="car-service" value="" checked={this.checkBox.carService} onChange={this.changeCheckbox.bind(this, 'carService')} />
                                              <label htmlFor="car-service" className="custom-checkbox"></label>
                                              <label htmlFor="car-service">
                                                Car Service
                                              </label>
                                            </div>
                                            <div className="checkbox-style checkbox-wrapper">
                                              <input type="checkbox" id="car-repair" value="" checked={this.checkBox.carRepair} onChange={this.changeCheckbox.bind(this, "carRepair")} />
                                              <label htmlFor="car-repair" className="custom-checkbox"></label>
                                              <label htmlFor="car-repair">
                                                Car Repair
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="f-card n-distance-range">
                                        <h5>Distance</h5>
                                        <InputRange
                                          formatLabel={distValue => `${distValue}km`}
                                          minValue={0}
                                          maxValue={100}
                                          value={this.state.distValue}
                                          onChange={distValue => this.setState({ distValue })} />
                                        <span className="range-min">{this.state.distValue.min + " Km"}</span>
                                        <span className="range-max">{this.state.distValue.max + " Km"}</span>
                                      </div>

                                      <div className="f-card openAlign n-time-range">
                                        <h5>Open Between</h5>
                                        <ul className="list-unstyled">
                                          <li className={this.state.daySelected["sunday"] ? 'active' : ''} onClick={this.day.bind(this, "sunday", 0)}>SUN</li>
                                          <li className={this.state.daySelected["monday"] ? 'active' : ''} onClick={this.day.bind(this, "monday", 1)}>MON</li>
                                          <li className={this.state.daySelected["tuesday"] ? 'active' : ''} onClick={this.day.bind(this, "tuesday", 2)}>TUE</li>
                                          <li className={this.state.daySelected["wednesday"] ? 'active' : ''} onClick={this.day.bind(this, "wednesday", 3)}>wed</li>
                                          <li className={this.state.daySelected["thrusday"] ? 'active' : ''} onClick={this.day.bind(this, "thrusday", 4)}>thu</li>
                                          <li className={this.state.daySelected["friday"] ? 'active' : ''} onClick={this.day.bind(this, "friday", 5)}>fri</li>
                                          <li className={this.state.daySelected["saturday"] ? 'active' : ''} onClick={this.day.bind(this, "saturday", 6)}>sat</li>
                                        </ul>
                                        <div className="row date-time model-select date-time-align">
                                          {/* <div className="col-md-6 padLeft0"> */}
                                          <span className="n-time-from">
                                            <TimePicker
                                              showSecond={false}
                                              className="custom-timepicker"
                                              format={'h:mm a'}
                                              value={this.state.rangeFromDefault}
                                              onChange={this.rangefrom.bind(this)}
                                              defaultValue={moment('2016-12-19T00:00:00+05:30')}
                                              use12Hours
                                            />
                                            <i className="mdi mdi-chevron-down time-to" />
                                          </span>
                                          <span className="time-to-time n-time-to">to</span>
                                          {/* </div> */}
                                          {/* <div className="col-md-6 padRight0 form-group error"> */}
                                          <span className="n-time-to">
                                            <TimePicker
                                              showSecond={false}
                                              className="custom-timepicker"
                                              format={'h:mm a'}
                                              value={this.state.rangeToDefault}
                                              onChange={this.rangeTo.bind(this)}
                                              defaultValue={moment('2016-12-19T23:59:00+05:30')}
                                              use12Hours
                                            />
                                            <i className="mdi mdi-chevron-down time-to" />
                                          </span>
                                          {/* </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="filter-right toggleBtn">
                                    <div className="filterby-wrapper">
                                      <div className="f-card toggleBtn">
                                        <h5>Open 24/7</h5>
                                        <ToggleSwitch
                                          checked={this.toggleSwitchVal.Open24_7}
                                          size="small"
                                          onChange={this.switch.bind(this, 'Open24_7')}
                                          ref={(node) => {
                                            this.toggleSwitch = node;
                                          }}
                                        />
                                      </div>
                                      <div className="f-card toggleBtn">
                                        <h5>Pickup / drop</h5>
                                        <ToggleSwitch
                                          checked={this.toggleSwitchVal.PickupDrop}
                                          size="small"
                                          onChange={this.switch.bind(this, 'PickupDrop')}
                                          ref={(node) => {
                                            this.toggleSwitch = node;
                                          }}
                                        />
                                      </div>
                                      <div className="f-card star-rating">
                                        <h5>Rating</h5>
                                        <Rating
                                          empty="mdi mdi-star-outline "
                                          full="mdi mdi-star active-star"
                                          initialRate={this.state.ratingValue}
                                          onChange={(e) => { this.ratingOnChange(e) }}
                                        />
                                      </div>

                                      {localStorage.getItem('authData') && <div className="f-card">
                                        <h5>Only show favourites</h5>
                                        <ToggleSwitch
                                          checked={this.toggleSwitchVal.showFavourites}
                                          size="small"
                                          onChange={this.switch.bind(this, 'showFavourites')}
                                          ref={(node) => {
                                            this.toggleSwitch = node;
                                          }}
                                        />
                                      </div>}

                                      <div className="f-card payment-type">
                                        <h5>Payment by</h5>
                                        <div className="holder">
                                          <span className="pad0">Pay by cash</span>
                                          <ToggleSwitch
                                            checked={this.toggleSwitchVal.byCash}
                                            size="small"
                                            onChange={this.switch.bind(this, 'byCash')}
                                            ref={(node) => {
                                              this.toggleSwitch = node;
                                            }}
                                          />
                                        </div>
                                        <div className="holder">
                                          <span className="">Pay by credit card</span>
                                          <ToggleSwitch
                                            checked={this.toggleSwitchVal.byCreditcard}
                                            size="small"
                                            onChange={this.switch.bind(this, 'byCreditcard')}
                                            ref={(node) => {
                                              this.toggleSwitch = node;
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="filter-footer footer">
                                    <a onClick={this.clearFilter.bind(this)}>Clear</a>
                                    <Button btnType="red" btnSize="sm" fontSize={15} label="Apply" btnCallBack={this.filterSelect.bind(this)} />
                                  </div>
                                </div>
                              </li>
                            </DropdownButton>
                          </div>}
                      </div>
                      {this.state.jobCardDetails && this.state.jobCardDetails.length ? <div className="quotes-left-body">
                        <div className="requestQuotesScroll">
                          <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true} scrollTo={this.state.scrollTo}>
                            <div className="wrapper" ref={'quotesList'}>
                              <div>
                                {map(this.state.jobCardDetails, (val, key) => {
                                  let coverImg = '';
                                  if (val && val.images && val.images.length) {

                                    imageExists(val.images[0].small, function(exists) {

                                      if (! exists) {
                                        if(val.images[0].small){
                                          imageExists(val.images[0].medium, function(exists) {

                                            if (! exists) {
                                              if(val.images[0].medium){
                                                coverImg = val.images[0].large;
                                              }

                                            }else{
                                              coverImg = val.images[0].medium;
                                            }


                                          });
                                        }

                                      }else{
                                        coverImg = val.images[0].small;
                                      }
                                    });


                                    console.log("coverImg",coverImg);

                                  }

                                  let companyprofilename = val.companyprofilename;
                                  companyprofilename = companyprofilename.replace(/\s*$/,'');

                                  return (
                                    <QuotesCard
                                      router={router}
                                      headingClickCallback=
                                      {this.headingClickCallback.bind(this,
                                        `${companyprofilename.replace(/[^A-Z0-9]+/ig, "-").toLowerCase()}`)}
                                      key={key}
                                      vendorId={val.id}
                                      isFavourite={val.isfavourite}
                                      ref={(quotesCard) => { val.isActive ? this.currentTopEle = quotesCard : '' }}
                                      activeClass={val.isActive ? "active" : ""}
                                      vendorName={val.companyprofilename}
                                      rating={val.rating}
                                      distance={val.distance && round(val.distance, 2)}
                                      reviews={val.reviews}
                                      btnClickFunc={this.btnClickFunc.bind(this, val)}
                                      viewMessaging={this.viewMessaging.bind(this)}
                                      ClickedQuoteCard={() => this.ClickedQuoteCard({ key })}
                                      phoneNo={val.phone}
                                      vendorImage={coverImg? coverImg : ''}
                                      removeFavourite={this.removeFav.bind()} />
                                  );
                                })}
                              </div>
                              {/*}*/}
                            </div>
                          </CustomScroll>
                        </div>
                      </div> : <SearchEmptyState />}
                    </div>
                  </div>
                  {this.state.jobCardDetails.length ? <div className={localStorage.getItem('authData') ? "col-md-6 clearfix right pad0" : "col-md-5 clearfix right pad0"}>
                    <div className={"mapSection"}>
                      <div className="quotes-right-body">
                        <Gmaps
                          mapDrag={() => { this.setState({ setCenter: false }) }}
                          setCenter={this.state.setCenter}
                          center={this.state.mapsCenter}
                          infoPopUp={true}
                          markers={{ jobCardLocation }}
                          markerClick={this.mapClick.bind(this)}
                          zoom={5}
                          containerElement={<div style={{ height: 100 + '%' }} />}
                          mapElement={<div style={{ height: 100 + '%' }} />}
                        />
                        <span onClick={this.setCenter.bind(this)} className="current-position"><i className="mdi mdi-crosshairs-gps"></i></span>
                      </div>
                    </div>
                  </div> : <div />}
                </div> : <div />}
              </div>
            </div>
          </div>
        </div>
        <CreateRequestPopup router={router} selectedVendorProfile={this.state.selectedVendorProfile} modalStatus={this.state.bookServiceModalVisible} hideModalCallback={this.hideModalCallback.bind(this)} />
        {this.state.mobileSortItem && <RequestMobileSort type="fav"
          filterSort={this.state.filterSort} back={this.bckButton.bind(this)}
          filterOption={this.filterOption.bind(this)} />}
        {this.state.mobileFilterItem && <RequestFilter hideOption={() => this.setState({ mobileFilterItem: false })}
          checkBox={this.checkBox}
          changeCheckbox={this.changeCheckbox.bind(this)}
          distValue={this.distanceRange.bind(this)}
          day={this.day.bind(this)}
          rangefrom={this.rangefrom.bind(this)}
          rangeTo={this.rangeTo.bind(this)}
          toggleSwitchVal={this.toggleSwitchVal}
          switch={this.switch.bind(this)}
          ratingOnChange={this.ratingOnChange.bind(this)}
          clearFilter={this.clearFilter.bind(this)}
          filterSelect={this.filterSelect.bind(this)}
          stateVal={this.state} />}
      </div>
    );

  }
}
